import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loaderspinner from "../Loader";
import { showToast, deleteResourceChecklist, getResourceChecklist } from "../../Pages/Utils/utils";
import { Row, Col, Modal } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";

const Checklist = ({ id }) => {
	const navigate = useNavigate()
	const [loading, setLoading] = useState(false)
	const [page, setPage] = useState(0);
	const [totalPages, setTotalPages] = useState(1);
	const [search, setSearch] = useState("");
	const [checkList, setCheckList] = useState([]);
	const [checklistId, setChecklistId] = useState(null);
	const [showAlert, setShowAlert] = useState(false);

	useEffect(() => {
		if (search.length == 0 || search.length >= 3) {
			fetchList();
		}
	}, [page, search]);

	const fetchList = async () => {
		try {
			setLoading(true);
			const limit = 10;
			const offset = page * limit;

			const response = await getResourceChecklist({ resource_id: id, search, limit, offset });

			if (response?.status == 200) {
				setCheckList(response?.data?.rows);
				if ((response?.data?.count || 0) < limit) {
					setTotalPages(page + 1);
				} else {
					setTotalPages(page + 2);
				}
			} else {
				console.log("cannot fetch checklist", response)
			}

		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	const openAnalytics = (referenceId, type, event) => {
		const breadcrumbs = [
			{ label: "Manage Resource", path: `/manage-resource/${id}` },
			{ label: "Checklist", path: `/manage-resource/${id}` }
		];
		navigate("/analytics-detail", {
			state: {
				reference_id: referenceId,
				type,
				event,
				breadcrumbs
			}
		});
	};

	const handleDelete = async () => {
		var res = await deleteResourceChecklist(checklistId)
		if (res.status == 200) {
			showToast("Deleted successfully", "success");
			fetchList();
		} else {
			showToast(res.data.message || res.message, "error");
		}
		setShowAlert(false);
	};


	return (
		<>
			{loading && <Loaderspinner />}
			<div className="">
				<div className="d-flex align-items-center justify-content-end mb-3">
					<input
						type="text"
						className="search-input mx-2"
						placeholder="Search"
						value={search}
						onChange={(e) => setSearch(e.target.value)}
					/>
					<Link to={`/create-checklist/${id}`}>
						<button className="export-btn"> Add Checklist </button>
					</Link>
				</div>
				<div className="row">
					<div className="col">
						<div className="table-responsive">
							<table className="table align-items-center table-flush">
								<thead className="thead-light">
									<tr>
										<th>Sr.No</th>
										<th>Title</th>
										<th>Subtitle</th>
										<th>File Url</th>
										<th>Cover Image</th>
										<th>Views</th>
										<th>Actions</th>
									</tr>
								</thead>
								<tbody>
									{checkList?.length > 0 ? (
										checkList.map((list, index) => (
											<tr key={index}>
												<td>{index + 1}</td>
												<td style={{ width: "130px" }}>{list?.title}</td>
												<td>
													<span className="truncate-text" style={{ whiteSpace: "pre-wrap" }}>
														{list?.sub_title}
													</span>
												</td>
												<td style={{ maxWidth: "330px" }}> <a
													className="truncate-text"
													href={list?.file_url}
													target="_blank"
													rel="noopener noreferrer"
													style={{ fontSize: "12px" }}
												// className="btn btn-sm btn-outline-primary"
												>
													{list.file_url}
												</a></td>
												<td style={{ width: "120px" }}>{list?.cover_url ? 'Yes' : 'No'}</td>
												<td style={{ width: "120px" }}>
													<button className="viewproject-btn pull-right" style={{ width: "fit-content" }} onClick={() => openAnalytics(list?.id, "resource_checklist", "view")}>
														{list?.view_count || 0}
													</button>
												</td>
												<td style={{ width: "140px" }}>
													<Link to={`/resources/${id}/edit-checklist/${list?.id}`}>
														<button className="viewproject-btn pull-right mb-1" >
															<span className="text-white">Edit</span>
														</button>
													</Link>
													<button className="viewproject-btn pull-right mb-1" onClick={() => {
														setChecklistId(list?.id)
														setShowAlert(true)
													}} >
														<span className="text-white">Delete</span>
													</button>
												</td>
											</tr>
										))) :
										<tr>
											<td colSpan="10" className="text-center"><b>No records found</b></td>
										</tr>
									}
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<Row>
					<Col xs={12}>
						<div className='paginate-css'>
							<ReactPaginate
								previousLabel="<"
								nextLabel=">"
								breakLabel="..."
								pageCount={totalPages}
								marginPagesDisplayed={1}
								pageRangeDisplayed={2}
								onPageChange={({ selected }) => setPage(selected)}
								containerClassName="pagination"
								activeClassName="active"
							/>
						</div>
					</Col>
				</Row>
			</div>
			{showAlert && (
				<SweetAlert
					warning
					showCancel
					confirmBtnText="Yes, delete it!"
					confirmBtnBsStyle="danger"
					cancelBtnBsStyle="secondary"
					title="Are you sure?"
					onConfirm={handleDelete}
					onCancel={() => setShowAlert(false)}
					focusCancelBtn
				>
					This action cannot be undone.
				</SweetAlert>
			)}
		</>
	);
};

export default Checklist;
